import React from 'react'
import Snackbar from 'britive-design-system/core/components/snackbar'
import Textfield from 'britive-design-system/core/components/textfield'
import Typography from 'britive-design-system/core/components/typography'
import QRCode from 'react-qr-code'

const TotpModelContent = ({
  mfaValidate,
  mfaRegister,
  toggleAlphanumericCodeModal,
  mfaOtp,
  setMfaOtp,
  isValidOtp,
}) => {
  return (
    <div className="user-mfa-registration-modal">
      {mfaValidate.error?.length && (
        <>
          <Snackbar errorList={[mfaValidate.error]} />
          <br />
        </>
      )}
      <Typography variant="heading6">
        {`Please use any Authenticator app to register your device using the QR code shown.`}
      </Typography>
      <br />
      <div className="qr-code-container">
        <div data-testid="qr-code" className="qr-code">
          <QRCode value={mfaRegister.data?.additionalDetails?.uri} />
        </div>
        <br />
        <div
          className="no-qr-code-option"
          data-testid="no-qr-code-option"
          onClick={toggleAlphanumericCodeModal}
        >
          <span>Unable to scan the QR code?</span>
        </div>
        <br />
        <Textfield
          label={''}
          value={mfaOtp}
          onChange={e => setMfaOtp(e.target.value)}
          error={mfaOtp?.length ? !isValidOtp() : false}
          errorMsg={mfaOtp?.length && !isValidOtp() ? 'Invalid OTP' : ''}
        />
      </div>
      <br />
      <Typography variant="heading6">
        {`After completing the device registration, please enter the OTP displayed on the Authenticator app and click on the "Register" button.`}
      </Typography>
    </div>
  )
}

export default TotpModelContent
